import axios from "axios";

const removeUser = ({ id }) => axios.delete(`users/${id}`);
const inviteUser = (params) => axios.post(`users/invite`, params);
const revokeInvite = ({ id }) => axios.delete(`users/invite/${id}`);
const acceptInvite = (params) => axios.post(`invite/accept`, params);

export { removeUser, inviteUser, acceptInvite, revokeInvite };
